module.exports = "<app-qavisit [title]=\"title\" [isReviewed] = \"isReviewed\" [hideActionsColumn]=\"hideActions\"></app-qavisit>"